// extracted by mini-css-extract-plugin
export var csatScore = "_o2-5";
export var header = "_o2-1";
export var panelWrapper = "_o2-2";
export var postPreview = "_o2-3";
export var rightContent = "_o2-0";
export var wrappingText = "_o2-4";